import { Component } from '@angular/core';
import {NgFor } from "@angular/common";

@Component({
  selector: 'app-important-tft',
  standalone: true,
  imports: [ NgFor ],
  templateUrl: '../../importancia-items/importancia-items.component.html',
  styleUrl: './important-tft.component.css'
})
export class ImportantTFTComponent {

  items = [
    {
      name: "Trabajo físico intenso",
      description: "Ayuda a prevenir y tratar lesiones donde se realizan actividades físicas exigentes (levantar cargas, movimientos repetitivos, o estar de pie por largos periodos).",
      icon: "/assets/img/enterprise/iconosImportancia/trabajoFisicoIntenso.svg"
    },
    {
      name: "Prevención de enfermedades laborales",
      description: "Prevención de trastornos como la lumbalgia, tendinitis o síndrome del túnel carpiano, promoviendo la salud postural y el bienestar físico.",
      icon: "/assets/img/enterprise/iconosImportancia/prevencionEnfermedadesLaborales.svg"
    },
    {
      name: "Rehabilitación tras accidentes laborales",
      description: "Permite una recuperación más rápida y eficiente para empleados que sufren lesiones durante el trabajo.",
      icon: "/assets/img/enterprise/iconosImportancia/rehabilitacionPorAccidentes.svg"
    },
    {
      name: "Mejora del rendimiento y bienestar",
      description: "Mejorar la calidad de vida de los empleados, reduciendo el ausentismo por dolores o malestares físicos.",
      icon: "/assets/img/enterprise/iconosImportancia/mejoraRendimientoLaboral.svg"
    }

  ]



}
